import { render, staticRenderFns } from "./FlipCardSide.vue?vue&type=template&id=763f1cf6"
import script from "./FlipCardSide.vue?vue&type=script&lang=js"
export * from "./FlipCardSide.vue?vue&type=script&lang=js"
import style0 from "./FlipCardSide.vue?vue&type=style&index=0&id=763f1cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports